import { cn } from "@gymflow/helpers";
import { DateRange } from "react-day-picker";

import { Button } from "../../Button";
import { CheckCircleFilledIcon } from "../../icons/CheckCircleFilledIcon";

type PredefinedRange = { label: string; range: DateRange };

type RangesColumnProps = {
  predefinedRanges: PredefinedRange[];
  range: DateRange;
  applyRange: (range: DateRange) => void;
};

const RangesColumn = ({
  predefinedRanges,
  range,
  applyRange,
}: RangesColumnProps) => {
  return (
    <div className="flex gap-1 overflow-x-auto border-b p-3 px-4 lg:flex-col lg:border-b-0 lg:border-r">
      {predefinedRanges.map((item) => {
        const isSelected =
          range?.from &&
          range?.to &&
          range.from?.toDateString() === item.range.from?.toDateString() &&
          range.to?.toDateString() === item.range.to?.toDateString();
        return (
          <Button
            key={item.label}
            size="small"
            className={cn(
              "text-gray-950 justify-start lg:w-[10rem] whitespace-nowrap rounded-[1.25rem] border-none min-w-auto text-left text-sm focus:outline-none focus:ring-0 focus:ring-offset-0 active:ring-0 active:ring-offset-0",
              {
                "hover:!bg-secondary-25 bg-secondary-25 !text-secondary-700 pointer-events-none justify-between":
                  isSelected,
                "text-gray-950": !isSelected,
              },
            )}
            onClick={() => applyRange(item.range)}
          >
            {item.label}
            {isSelected && (
              <div className="bg-secondary-500 ml-2 flex size-4 items-center justify-center rounded-full">
                <CheckCircleFilledIcon className="size-3" />
              </div>
            )}
          </Button>
        );
      })}
    </div>
  );
};

export default RangesColumn;
